export enum QuestionType {
  Heatmap = 'heatmap',
  InfoPage = 'infoPage',
  Dropdown = 'dropdown',
  Essay = 'essay',
  MultiChoice = 'multiChoice',
  FileUpload = 'fileUpload',
  Rating = 'rating',
  SingleChoice = 'singleChoice',
  Input = 'input',
  Carousel = 'Carousel',
  CarouselMultiChoice = 'CarouselMultiChoice',
  CarouselRating = 'CarouselRating',
  Terminate = 'Terminate',
  HiddenChoice = 'hiddenChoice',
  AIChat = 'AIChat',
  NPS = 'NPS',
  Ranking = 'ranking',
  RankSort = 'rankSort'
}

export const CarouselType = [QuestionType.Carousel, QuestionType.CarouselMultiChoice, QuestionType.CarouselRating];

export const ChoiceQuestionTypes = [
  QuestionType.SingleChoice,
  QuestionType.MultiChoice,
  QuestionType.Carousel,
  QuestionType.CarouselMultiChoice,
  QuestionType.Dropdown
];

export enum ExtendedRatingQuestionType {
  RatingNumeric = 'rating-numeric',
  RatingDescriptive = 'rating-descriptive',
  RatingStars = 'rating-stars'
}
export enum ExtendedRankSortQuestionType {
  RankSortNumeric = 'rank-sort-numeric',
  RankSortDescriptive = 'rank-sort-descriptive'
}
export const MultiChoiceQuestionTypes = [QuestionType.MultiChoice, QuestionType.HiddenChoice, QuestionType.CarouselMultiChoice];
export const SingleChoiceQuestionTypes = [QuestionType.SingleChoice, QuestionType.Dropdown, QuestionType.Rating];

export const AllowedForCopyCardsQuestionTypes = [QuestionType.Carousel, QuestionType.CarouselMultiChoice, QuestionType.CarouselRating];

export const AllowedForCopyOptionsQuestionTypes = [
  QuestionType.SingleChoice,
  QuestionType.MultiChoice,
  QuestionType.Carousel,
  QuestionType.CarouselMultiChoice,
  QuestionType.Dropdown,
  QuestionType.Rating,
  QuestionType.CarouselRating,
  QuestionType.Ranking,
  QuestionType.RankSort
];

export const AllowedForCrosstabQuestionTypes = [
  QuestionType.MultiChoice,
  QuestionType.SingleChoice,
  QuestionType.Dropdown,
  QuestionType.Rating,
  QuestionType.HiddenChoice,
  QuestionType.NPS,
  QuestionType.Ranking,
  QuestionType.RankSort
];
export const AllowedForQuotasQuestionTypes = [QuestionType.MultiChoice, QuestionType.SingleChoice, QuestionType.Dropdown, QuestionType.HiddenChoice];
export const ExcludedFromAnalytics = [QuestionType.InfoPage, QuestionType.Terminate];
export const ExcludedFromExcelExport = [QuestionType.Heatmap, QuestionType.InfoPage, QuestionType.Terminate];
export const RankingTypes = [QuestionType.Ranking, QuestionType.RankSort];
export const MonitorTermsQuestionTypes = [QuestionType.Essay, QuestionType.Input];
export const QuestionTypesNoAvailableForConditionallity = [
  QuestionType.InfoPage,
  QuestionType.Terminate,
  QuestionType.FileUpload,
  QuestionType.AIChat,
  QuestionType.Heatmap
];
